(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react/jsx-runtime"), require("react-dom"), require("react-dom/client"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react/jsx-runtime", "react-dom", "react-dom/client"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react/jsx-runtime"), require("react-dom"), require("react-dom/client")) : factory(root["React"], root["React"], root["ReactDOM"], root["ReactDOM"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__38036__, __WEBPACK_EXTERNAL_MODULE__34925__, __WEBPACK_EXTERNAL_MODULE__6047__, __WEBPACK_EXTERNAL_MODULE__3765__) => {
return 